// 导入axios
import axios from 'axios'
import baseUrl from './base'
import commonfun from '@/commonfun'
import { message } from '@/message/index.js'
import i18n from '@/tools/i18n'

// 使用element-ui Message做消息提醒
// 1. 创建新的axios实例，
var request = function (config) {
  return new Promise((resolve, reject) => {
    switch (config.baseUrl) {
      case 'infoApi':
        config.baseUrl = baseUrl.infoApi
        break
      case 'Api':
        config.baseUrl = baseUrl.Api
        break
      case 'webUrl':
        config.baseUrl = baseUrl.webUrl
        break
      case 'deviceApi':
        config.baseUrl = baseUrl.deviceApi
        break
      default:
        config.baseUrl = baseUrl.infoApi
    }
    const service = axios.create({
      // 公共接口--这里注意后面会讲
      baseURL: config.baseUrl,
      // 超时时间 单位是ms，这里设置了300s的超时时间
      timeout: 300 * 1000
    })
    // 2.请求拦截器
    service.interceptors.request.use(config => {
      // 发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等
      // config.data = JSON.stringify(config.data)
      return config
    }, error => {
      reject(error)
    })
    // 3.响应拦截器
    service.interceptors.response.use(response => {
      // 接收到响应数据并成功后的一些共有的处理，关闭loading等
      return response
    }, error => {
      var PopupPrompt = true
      // 接收到异常响应的处理开始
      if (error && error.response) {
        // 1.公共错误处理
        // 2.根据响应码具体处理
        if (error.response.status === 400) {
          switch (error.response.data.code) {
            case 10000:
              error.message = i18n.t('LanguageLib.InfoServerBusy')
              break
            case 10011:
              error.message = i18n.t('LanguageLib.InfoServerBusy')
              break
            case 10001:
              error.message = i18n.t('LanguageLib.InfoDataNoExist')
              break
            case 10002:
              error.message = i18n.t('LanguageLib.InfoNoLoginRights')
              break
            case 10003:
              error.message = i18n.t('LanguageLib.InfoSubmitFailed')
              break
            case 10004:
              error.message = i18n.t('LanguageLib.InfoServerBusy')
              break
            case 10005:
              error.message = i18n.t('LanguageLib.InfoCreationFailed')
              break
            case 10006:
              error.message = i18n.t('LanguageLib.FAILED_TO_DELETE2')
              break
            case 10007:
              error.message = i18n.t('LanguageLib.InfoUpdateFailed')
              break
            case 10008:
              error.message = i18n.t('LanguageLib.InfoAgainLogin')
              setTimeout(function () {
                commonfun.localStorage.clearall()
                window.location.href = '/login'
              }, 1000)
              break
            case 10009:
              error.message = i18n.t('LanguageLib.InfoAccountCannotEmpty')
              break
            case 10010:
              error.message = i18n.t('LanguageLib.ACCOUNT_PASSWORD_CANNOT_EMPTY')
              break
            case 10012:
              error.message = i18n.t('LanguageLib.InfoServerBusy')
              break
            case 10013:
              error.message = i18n.t('LanguageLib.InfoInvalidEnterpriseWechatAuthcode')
              break
            case 10014:
              error.message = i18n.t('LanguageLib.InfoAccountNoExist')
              break
            case 10015:
              error.message = i18n.t('LanguageLib.InfoCompanyDeleted')
              break
            case 10016:
              error.message = i18n.t('LanguageLib.InfoCompanyFrozen')
              break
            case 10017:
              error.message = i18n.t('LanguageLib.InfoAccountNoExist')
              break
            case 10018:
              error.message = i18n.t('LanguageLib.InfoUserDeleted')
              break
            case 10019:
              error.message = i18n.t('LanguageLib.InfoUserFrozen')
              break
            case 10020:
              error.message = i18n.t('LanguageLib.InfoNotSystemAdministrator')
              break
            case 10021:
              error.message = i18n.t('LanguageLib.InfoPasswordError')
              break
            case 10022:
              error.message = i18n.t('LanguageLib.InfoCompanyExpired')
              break
            case 10023:
              error.message = i18n.t('LanguageLib.InfoNameAlreadyExists')
              break
            case 10024:
              error.message = i18n.t('LanguageLib.InfoOrganizationTypeNoExist')
              break
            case 10025:
              error.message = i18n.t('LanguageLib.InfoSuperiorOrganizationNoExist')
              break
            case 10026:
              error.message = i18n.t('LanguageLib.InfoStoreNoExist')
              break
            case 10027:
              error.message = i18n.t('LanguageLib.InfoStoreOrganizationNoExist')
              break
            case 10028:
              error.message = i18n.t('LanguageLib.InfoStoreCodeAlreadyExists')
              break
            case 10029:
              error.message = i18n.t('LanguageLib.InfoStoreExistingPosition')
              break
            case 10030:
              error.message = i18n.t('LanguageLib.InfoOrganizationExistingPosition')
              break
            case 10031:
              error.message = i18n.t('LanguageLib.InfoSubsetsOrganizations')
              break
            case 10032:
              error.message = i18n.t('LanguageLib.InfoOrganizationTypeIsShop')
              break
            case 10033:
              error.message = i18n.t('LanguageLib.InfoOrganizationTypeNotModified')
              break
            case 10034:
              error.message = i18n.t('LanguageLib.InfoWechatSynchronization')
              break
            case 10035:
              error.message = i18n.t('LanguageLib.UnorganizedConvertedStores')
              break
            case 10036:
              error.message = i18n.t('LanguageLib.OrganizationSubordinateOrganizations')
              break
            case 10037:
              error.message = i18n.t('LanguageLib.EnterpriseSynchronizationOnly')
              break
            case 10038:
              error.message = i18n.t('LanguageLib.INFO_TIPS_PERSON')
              break
            case 10039:
              error.message = i18n.t('LanguageLib.WorkMailboxAlreadyExists')
              break
            case 10040:
              error.message = i18n.t('LanguageLib.PersonnelDoesNotExist')
              break
            case 10041:
              error.message = i18n.t('LanguageLib.LABEL_NAME_ALREADY_EXISTS')
              break
            case 10042:
              error.message = i18n.t('LanguageLib.LABEL_DOES_NOT_EXIST')
              break
            case 10043:
              error.message = i18n.t('LanguageLib.TYPE_NAME_ALREADY_EXISTS')
              break
            case 10044:
              error.message = i18n.t('LanguageLib.TYPE_IS_BEING_NOT_ALLOWED_DELETE')
              break
            case 10045:
              error.message = i18n.t('LanguageLib.NO_DATA_DELETE')
              break
            case 10046:
              error.message = i18n.t('LanguageLib.NOT_EDIT_TYPE')
              break
            case 10047:
              error.message = i18n.t('LanguageLib.NOT_DELETE_TYPE')
              break
            case 10048:
              error.message = i18n.t('LanguageLib.THE_ROLE_NAME_ALREADY_EXISTS')
              break
            case 10049:
              error.message = i18n.t('LanguageLib.USER_TYPE') + i18n.t('LanguageLib.CAN_NOT_BE_EMPTY')
              break
            case 10050:
              error.message = i18n.t('LanguageLib.CURRENT_USER_TYPE_NOT_EDIT')
              break
            case 10051:
              error.message = i18n.t('LanguageLib.ROLE_POSITION_IS_USE_NOT_DELETE')
              break
            case 10052:
              error.message = i18n.t('LanguageLib.LEAEVE_NOT_OVER')
              break
            case 10053:
              PopupPrompt = false // 不弹提示
              break
            case 10054:
              error.message = i18n.t('LanguageLib.BRAND_NO_DELETE_INFO')
              break
            case 10055:
              error.message = error.message = i18n.t('LanguageLib.INFO_TIPS_PERSON')
              break
            case 10056:
              error.message = i18n.t('LanguageLib.ACCOUNT_HAVE_DELETE_INFO')
              break
            case 10057:
              error.message = i18n.t('LanguageLib.ADD_FAILED_THE_BRAND_ALREADY_EXISTS')
              break
            case 10058:
              error.message = i18n.t('LanguageLib.USER_HAS_RESIGNED')
              break
            case 10059:
              error.message = i18n.t('LanguageLib.COSTUMER_NAME_EXISTS')
              break
            case 10060:
              error.message = i18n.t('LanguageLib.COSTUMER_CODE_EXISTS')
              break
            case 10061:
              error.message = i18n.t('LanguageLib.AREA_NAME_EXISTS')
              break
            case 10062:
              error.message = i18n.t('LanguageLib.AREA_CODE_EXISTS')
              break
            case 10063:
              error.message = i18n.t('LanguageLib.VERSION_EXCEPTION')
              break
            case 10064:
              error.message = i18n.t('LanguageLib.UN_INPUT_OPTION_EXIST')
              break
            case 10065:
              error.message = i18n.t('LanguageLib.FIELD_NOT_ALLOWED_REPEAT')
              break
            case 10066:
              error.message = i18n.t('LanguageLib.DEFAULT_LANG_CATEGORY_NAME_REQUIRED')
              break
            case 10067:
              error.message = i18n.t('LanguageLib.UNDER_SAME_PARENT_CATEGORY_NAME_NOT_ALLOWED_REPEAT')
              break
            case 10068:
              error.message = i18n.t('LanguageLib.UNDER_SAME_PARENT_CATEGORY_NO_NOT_ALLOWED_REPEAT')
              break
            case 10069:
              error.message = i18n.t('LanguageLib.ID_CAN_NOT_EMPTY_WHEN_UPDATE')
              break
            case 10070:
              error.message = i18n.t('LanguageLib.PARENT_IS_WITHDRAWED')
              break
            case 10071:
              error.message = i18n.t('LanguageLib.UNDER_SAME_PARENT_PROP_ENG_NAME_NOT_ALLOWED_REPEAT')
              break
            case 10072:
              error.message = i18n.t('LanguageLib.UNDER_SAME_PARENT_PROP_NAME_NOT_ALLOWED_REPEAT')
              break
            case 10073:
              error.message = i18n.t('LanguageLib.MAINTENANCE_FAULT_CLASSIFICATION_NAME') + i18n.t('LanguageLib.CAN_NOT_REPEAT')
              break
            case 10074:
              error.message = i18n.t('LanguageLib.DATA_HAS_BEEN_USED')
              break
            case 10075:
              error.message = i18n.t('LanguageLib.SAME_MNT_QUESTION_CATEGORY_QUESTION_NAME_CAN_NOT_REPEAT')
              break
            default:
              error.message = `连接错误${error.response.status}`
          }
        } else {
          switch (error.response.status) {
            case 401:
              error.message = i18n.t('LanguageLib.InfoUnauthorized')
              break
            case 403:
              error.message = i18n.t('LanguageLib.InfoAccessDenied')
              break
            case 404:
              error.message = i18n.t('LanguageLib.InfoRequestError')
              break
            case 405:
              error.message = i18n.t('LanguageLib.InfoRequestMethodNoAllowed')
              break
            case 408:
              error.message = i18n.t('LanguageLib.InfoRequestTimeout')
              break
            case 500:
              error.message = i18n.t('LanguageLib.InfoServerSideError')
              break
            case 501:
              error.message = i18n.t('LanguageLib.InfoNetworkNoImplemented')
              break
            case 502:
              error.message = i18n.t('LanguageLib.InfoNetworkError')
              break
            case 503:
              error.message = i18n.t('LanguageLib.InfoServiceNoAvailable')
              break
            case 504:
              error.message = i18n.t('LanguageLib.InfoNetworkTimeout')
              break
            case 505:
              error.message = i18n.t('LanguageLib.InfoNoSupportedRequest')
              break
            default:
              error.message = `连接错误${error.response.status}`
          }
        }
      } else {
        // 超时处理
        if (JSON.stringify(error).includes('timeout')) {
          error.message = i18n.t('LanguageLib.InfoServerResponseTimeout')
        } else {
          error.message = i18n.t('LanguageLib.InfoConnectServerFailed')
        }
      }
      if (PopupPrompt) {
        message.error(error.message)
      }
      // 处理结束
      // 如果不需要错误处理，以上的处理过程都可省略
      return reject(error.response)
    })
    service(config)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 4.导入文件
export default request
